import {SpotlightSection_TeaserElement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {SlideAmbientProps} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {StyledBrandLogo} from './Shared';
import {SlidePropsType} from './types';

export const TeaserContent: FC<
  {
    teaser: SpotlightSection_TeaserElement;
  } & SlidePropsType & {SlideUIComponent: FC<SlideAmbientProps>}
> = ({
  teaser,
  isActive,
  isCloseToViewport,
  onSlideClick,
  'data-testid': dataTestid,
  SlideUIComponent,
  uniqueKey = '',
  ...rest
}) => {
  return (
    <SlideUIComponent
      {...rest}
      uniqueKey={uniqueKey}
      data-testid={dataTestid}
      slideImage={teaser.coverSquareImage}
      bannerTarget={{
        url: teaser.linkTarget.url,
        external: teaser.linkTarget.external,
      }}
      subline={teaser.topline}
      headline={teaser.headline}
      isActive={Boolean(isActive)}
      isCloseToViewport={Boolean(isCloseToViewport)}
      onSlideClick={onSlideClick}
      brandLogo={
        <>
          {teaser.logoTransparentImage && (
            <StyledBrandLogo
              name={teaser.logoTransparentImage.description}
              image={teaser.logoTransparentImage}
              maxHeight="50px"
            />
          )}
        </>
      }
    />
  );
};
